export default {
  name: "Appendix B - Additional Worksite Information",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify in Field F.b.1 whether work is being performed at multiple worksites.",
        type: "info",
        isVisible: {
          when: "isMultipleLocations occupationType",
          is: [
            [undefined, null],
            [
              "professional_occupation",
              "non_professional",
              "college_university_teacher",
              "schedule_a",
              undefined,
              null,
            ],
          ],
          operator: "compareMultiFieldValuesAND_ORInArray",
        },
      },
      {
        title: "Section Complete",
        description: `Because you indicated that there are no additional worksites. This section is not necessary.`,
        type: "success",
        isVisible: {
          when: "isMultipleLocations",
          is: ["No"],
          operator: "||",
        },
      },
      {
        title: "Section Complete",
        description: `Because you indicated that this application is for a professional athlete, this section is not necessary.`,
        type: "success",
        isVisible: {
          when: "occupationType",
          is: ["professional_athlete"],
          operator: "||",
        },
      },
    ],
  },
  pageInfo: {
    text: `<b><u>Note:</u></b> Employers are required to complete Appendix B when “Yes” is marked for question b.1 under Section F on the Form ETA-9089, indicating that work for the job opportunity will be performed in geographic areas other than the one identified under Section F.a on the application.<br/><br/>If filing electronically, Appendix B will be available in the electronic filing system.  If filing by mail, the employer must download and submit the Form ETA-9089, Appendix A, and all other required appendices in order for the application to be considered complete.<b><i> In accordance with 20 CFR 656.17(a), the Department will not certify incomplete applications.</i></b> Applications and documents submitted by mail should include a cover page with the name, title, address, and phone number of the point of contact.  The cover page should also index the documents included in the mailing.<br/><br/>This Appendix will collect five (5) sections of additional worksite information.  For electronic filings, if the employer needs to disclose more sections of information, the filing system will automatically provide the employer with the option of adding more sections of this Appendix until all required responses are completed.  For mailed or paper filings, the employer will make one or more copies of this Appendix to complete and attach to the Form ETA-9089.  If the employer is required to undergo supervised recruitment in accordance with 20 CFR 656.21, the Certifying Officer may complete this Appendix, on behalf of the employer and as applicable.  All filers must review the Form ETA-9089 for completeness and accuracy prior to submission either by electronic filing or by mail.<br/><br/><b><i>Submission of additional worksite information in any other form or format will not be accepted.  Additional worksites must be one or more of the additional worksites identified in Appendix A of the Form ETA-9141 for this specific job opportunity associated with the PWD tracking number in section E.1 of the Form-ETA-9089 and must have the appropriate wage offer rate.  Worksites within the same BLS Area (Metropolitan or Non-Metropolitan Statistical Areas) should also be listed if a Notice of Filing will be posted at that location.</i></b>`,
    coloring: "grey",
    isVisible: {
      when: "isMultipleLocations",
      is: ["Yes"],
      operator: "||",
      hideStyles: true,
    },
  },
  sections: [
    {
      code: "Appendix B",
      name: "Additional Places of Employment",
      sectionInfo: {
        text: `<b><u>Note:</u></b> if you have a large amount of worksites the tables below may take a few moments to load</b>.`,
        coloring: "grey",
      },
      isVisible: {
        when: "isMultipleLocations",
        is: ["Yes"],
        operator: "||",
        hideStyles: true,
      },
      fields: [
        {
          machine_name: "appx_b",
          widget: "tableLoader",
          value: [],
          disableWhenField: {
            type: "button",
            when: [
              {
                when: "jobOppPWDNumber",
              },
            ],
          },
          widgetConfig: {
            fromField: "appx_b_worksites",
            toField: "appx_b",
            buttonText: "Add Worksites",
          },
        },
        {
          code: "Appendix B",
          machine_name: "appx_b",
          value: [],
          widget: "tableEditor",
          validate: ["tableRequired", "tableIncomplete"],
          fromFields: ["_blsCounties"],
        },
      ],
    },
  ],
};
